var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Col, Row } from "@folio/stripes/components";
import { Controller } from "react-hook-form";
import { AccordionSection } from "../../../AccordionSection";
import { RecekTextField } from "../../../inputs";
export var ContactSection = function (_a) {
    var control = _a.control, open = _a.open, onToggle = _a.onToggle;
    return (React.createElement(AccordionSection, { id: "progress-report-contact", labelId: "ui-br-agency.outputs.progress-report.section.contact", open: open, onToggle: onToggle },
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "contactPerson", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.contactPerson" })));
                    } })),
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "organization", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.organization" })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "department", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.department" })));
                    } })),
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "street", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.street" })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "city", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.city" })));
                    } })),
            React.createElement(Col, { xs: 6 },
                React.createElement(Controller, { control: control, name: "country", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.country" })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "telephone1", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.telephone1" })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "telephone2", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.telephone2" })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "telephone3", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.telephone3" })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "email1", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.email1", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "email2", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.email2", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "email3", render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.email3", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                    } }))),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "fax", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.fax" })));
                    } })),
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "url", render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.outputs.progress-report.field.url" })));
                    } })))));
};
